import Rollbar from 'rollbar';
import Vue from 'vue';

const rollbar = new Rollbar({
  accessToken: ''
});

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_ENV !== 'test') {
  const rollbarConfig = {
    accessToken: process.env.VUE_APP_ROLLBAR_POST_CLIENT_ITEM_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    hostWhiteList: ['office.shippio.io', 'staging.office.shippio.io', 'demo.office.shippio.io'],
    payload: {
      environment: process.env.VUE_APP_ENV || process.env.NODE_ENV
    }
  };
  rollbar.configure(rollbarConfig);
  Vue.config.errorHandler = (e) => {
    rollbar.error(e);
  };
  Vue.config.warnHandler = (e) => {
    rollbar.warning(e);
  };
}

export default rollbar;
